import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { logout } from '../store/slices/authSlice';
import { logoutUser } from '../services/api';
import AdminSidebar from './components/AdminSidebar';
import './AdminLayout.css';

function AdminLayout({ children }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth > 768);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setSidebarOpen(true);
      } else {
        setSidebarOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleLogout = async () => {
    try {
      await logoutUser();
    } catch (err) {
      console.error('Logout error:', err);
    } finally {
      dispatch(logout());
      navigate('/admin/login');
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape' && window.innerWidth <= 768 && sidebarOpen) {
      setSidebarOpen(false);
    }
  };

  if (!user || !['admin', 'superadmin'].includes(user.role)) {
    return null;
  }

  return (
    <div className="admin-layout" onKeyDown={handleKeyDown}>
      <AdminSidebar userRole={user.role} isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      {sidebarOpen && window.innerWidth <= 768 && (
        <div 
          className="sidebar-overlay" 
          onClick={() => setSidebarOpen(false)}
          aria-hidden="true"
        />
      )}
      <div className={`admin-content ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
        <div className="admin-header">
          <div className="header-left">
            <button
              className="sidebar-toggle"
              onClick={toggleSidebar}
              aria-label="Toggle sidebar navigation"
              aria-expanded={sidebarOpen}
              aria-controls="admin-sidebar"
            >
              <span className="hamburger-icon">
                <span></span>
                <span></span>
                <span></span>
              </span>
            </button>
            <h1>Admin Dashboard</h1>
          </div>
          <div className="admin-header-actions">
            <span className="admin-user-info" aria-label={`Logged in as ${user.email}`}>
              {user.email}
            </span>
            <button 
              className="logout-button" 
              onClick={handleLogout}
              aria-label="Logout from admin dashboard"
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  handleLogout();
                }
              }}
            >
              Logout
            </button>
          </div>
        </div>
        <div className="admin-main">
          {children}
        </div>
      </div>
    </div>
  );
}

export default AdminLayout;

